// Charte de management visuel — la couleur d'un chiffre traduit la PERSPECTIVE
// DE RENTABILITÉ ET DE TRÉSORERIE DE L'HUILERIE, jamais le signe mathématique.
//
//   vert   = favorable  : encaissements, ventes, marges positives, bonus de
//                         rendement, économie d'achat par rapport au cours
//   rouge  = défavorable: décaissements, paiements fournisseurs, dépenses,
//                         frais bancaires, surcoût d'achat, malus, marges négatives
//   neutre = informatif : soldes, provisions, cours de référence, quantités,
//                         dettes engagées dont l'argent n'est pas encore sorti
//   alerte = ambre      : écart de rapprochement, en attente, échéance dépassée

export const FAVORABLE = 'text-emerald-700';
export const DEFAVORABLE = 'text-red-700';
export const NEUTRE = 'text-slate-900';
export const NEUTRE_DOUX = 'text-slate-600';
export const ALERTE = 'text-amber-800';

export const FOND_FAVORABLE = 'bg-emerald-50';
export const FOND_DEFAVORABLE = 'bg-red-50';

// Gain (positif) → vert, perte (négatif) → rouge, nul ou inconnu → neutre.
export const couleurGain = (valeur, neutre = NEUTRE_DOUX) => {
  const v = Number(valeur);
  if (!Number.isFinite(v) || v === 0) return neutre;
  return v > 0 ? FAVORABLE : DEFAVORABLE;
};

// Coût ou charge : plus c'est élevé, plus c'est défavorable (surcoût → rouge,
// économie → vert). Utilisé pour les écarts de prix d'achat vs cours du marché.
export const couleurCout = (valeur, neutre = NEUTRE_DOUX) => couleurGain(-Number(valeur || 0), neutre);

// Sens de trésorerie : 'encaissement' (vert), 'decaissement' (rouge), sinon neutre.
export const couleurFlux = (sens) =>
  sens === 'encaissement' ? FAVORABLE : sens === 'decaissement' ? DEFAVORABLE : NEUTRE;

// Solde de compte : neutre par principe, rouge seulement en découvert.
export const couleurSolde = (valeur) => (Number(valeur) < 0 ? DEFAVORABLE : NEUTRE);

// Signe explicite, indépendant de la couleur.
export const signe = (valeur) => (Number(valeur) >= 0 ? '+' : '−');

// Ligne de grand livre tiers : seuls les flux de trésorerie sont colorés.
// Un achat ou une facture est un engagement (neutre) tant que l'argent n'a pas bougé.
export const couleurLigneTiers = (nature, colonne) => {
  if (colonne === 'debit') return nature === 'paiement' ? DEFAVORABLE : NEUTRE_DOUX;
  if (colonne === 'credit') return nature === 'encaissement' ? FAVORABLE : NEUTRE_DOUX;
  return NEUTRE;
};
